import Vue from "vue";

export default {
    RECORD_FILE_INIT: function(state, data) {
        state.recordFileList = data;
    },
    RECORD_FILE_ADD: function(state, {record}) {
        let obj = state.recordFileList.find(el => el.recordId === record.recordId);
        if(!obj)
            state.recordFileList.unshift(record);
    },
    RECORD_FILE_REMOVE: function(state, { recordId }) {
        state.recordFileList = state.recordFileList.filter(el => el.recordId !== recordId);
    },
    CHANGE_CLIENT_RECORD_STATE: function(state, data) {
        state.recordState = data.state || data;
        state.recordingTime = data.recordingTime || 0;
    },
    CHANGE_CLIENT_RECORD_TIME: function(state, data) {
        state.recordingTime = data || 0;
    },
    RECORD_SERVER_SEND_REMAIN_START: function(state, data){
        state.recordRemainData = Object.assign({}, state.recordRemainData, data);
    },
    RECORD_SERVER_SEND_REMAIN_PROGRESS: function(state, data){
        state.recordRemainData = Object.assign({}, state.recordRemainData, data);
    },
    RECORD_ERROR: function(state, data){
        state.recordError = true;
        state.recordErrorMessage = data;
    },
    // updateRecordFileList: function(state, data) {
    //     state.recordFileList = data;
    // },
    UPDATE_RECORD_DOWNLOAD_PROGRESS: function(state, data) {
        let {recordFile, progress, downloadState} = data;
        
        // let idx = state.recordFileList.indexOf(recordFile);
        let file = state.recordFileList.find(rec => rec.recordId == recordFile.recordId);
        if(!file){
            console.warn('record file is null', recordFile);
            return;
        }
        
        if(progress != undefined){
            if(!file.progress) {
                Vue.set(file, 'progress');
            }            
            file.progress = progress;
        }

        if(downloadState){
            if(!file.downloadState) {
                Vue.set(file, 'downloadState');
            }
            file.downloadState = downloadState;
        }
    },
    ADD_RECORD_FILE_INSTANCE: function(state, { recordId, instance }) {
        Vue.set(state.recordFileInstanceObj, recordId, [
          ...new Set([
            ...(state.recordFileInstanceObj[recordId] || []),
            ...instance
          ])
        ]);
    },
    REMOVE_RECORD_FILE_INSTANCE: function(state, { recordId }) {
        if (!state.recordFileInstanceObj[recordId]) {
            console.warn('recordFileInstanceObj is not exist', recordId);
            return;
        }

        state.recordFileInstanceObj[recordId].forEach((instance) => {
            if (instance?.destroy) {
                instance.destroy();
            } else {
                instance.remove();
            }
        })
        delete state.recordFileInstanceObj[recordId];
    }
}
